// extracted by mini-css-extract-plugin
export default {"root":"ProjectView_root__ryNsK","title":"ProjectView_title__cWaZx","img":"ProjectView_img__hLJVf","footer":"ProjectView_footer__r7w7G"};